import { FC, PropsWithChildren, useMemo, useReducer } from 'react'

import {
  FiltersContextProvider,
  offersStatusList,
  initialFiltersState,
  FilterContextType,
} from '~contexts'
import { filtersReducer } from '~filtersReducer'
export const FiltersProvider: FC<PropsWithChildren> = ({ children }) => {
  const [filtersState, filtersDispatch] = useReducer(filtersReducer, initialFiltersState)
  const value: FilterContextType = useMemo(
    () => ({
      filtersState,
      filtersDispatch,
      offersStatusList,
    }),
    [filtersState]
  )
  return <FiltersContextProvider value={value}>{children}</FiltersContextProvider>
}
